import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data.map(({ _id, name }) => ({
      id: _id,
      text: name,
    }))
  }, [data])
}
